/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register('./sw.js', {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
      if (Notification) {
        Notification.requestPermission(function (status) {
          if (status === "granted") {
            console.log('granted');
          } else {
            console.log('not granted');
          }
        });
      } else {
        console.log('not support');
      }
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      if (Notification) {
        Notification.requestPermission(function (status) {
          if (status === "granted") {
            console.log('granted');
          } else {
            console.log('not granted');
          }
        });
      } else {
        console.log('not support');
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
